export const FONT = "trebuc";
export const FONT_BOLD = "trebucBold"
export const FONT_STYLE= "normal"
export const DATE_FORMAT = "DD/MM/YYYY"
export const TIME_FORMAT = "HH:mm"
export const FILENAME_VOUCHER = "Kirkit Voucher"
